import { ANALYSIS_KEY_MAP } from './constants';

import type { ScaleConfig, ScalePoint } from './types';

export const toRgba = (hexColor: string, alpha: number): string => {
    const normalized = hexColor.replace('#', '');
    if (normalized.length !== 6) return hexColor;

    const red = Number.parseInt(normalized.slice(0, 2), 16);
    const green = Number.parseInt(normalized.slice(2, 4), 16);
    const blue = Number.parseInt(normalized.slice(4, 6), 16);

    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};

export const buildGradient = (points: ScalePoint[]) => {
    const lastIndex = points.length - 1;
    return `linear-gradient(90deg, ${points
        .map((point, index) => `${point.color} ${(index / lastIndex) * 100}%`)
        .join(', ')})`;
};

export const resolveSelectedKey = (value: string | undefined, config: ScaleConfig) => {
    const normalized = value?.toLowerCase();
    if (normalized && ANALYSIS_KEY_MAP[config.metric].includes(normalized)) {
        return normalized;
    }
    return config.defaultKey;
};
